/**
 * The six OnePass steps, shared by the header progress bar and the OnePass
 * Activity panel. Both read from here and from a single step index, so the two
 * can never disagree about where the user is or what they owe next.
 */
export const WORKFLOW_STEPS = [
  "Describe",
  "Validated Blueprint",
  "Correction Loop",
  "Approval",
  "Blueprint Summary",
  "Export",
];

export const TOTAL_STEPS = WORKFLOW_STEPS.length;

/**
 * The action that completes each step. The page passes a more specific string
 * when it knows one (e.g. intake analyzed but the Flow Map still missing);
 * otherwise these are used.
 */
export const DEFAULT_NEXT_ACTION = [
  "Generate Flow Map",
  "Run Validation",
  "Fix flagged issues & re-validate",
  "Approve & Lock Blueprint",
  "Review Blueprint Summary",
  "Export to coding tools",
];
